import {
  getAffiliate,
  getAffiliateOdontograms,
  getAffiliateTopBenefits,
  getAffiliatePharmaciesConsumptions,
  getAffiliatePKIs,
} from '@/services/affiliates.service';

import { redirectNotFound } from '@/utils/errorRedirect';

const Model = {
  namespace: 'affiliateDetail',
  state: {
    pkis: null,
    consumptions: null,
    topBenefits: null,
    canBeStudent: false,
    affiliate: undefined,
  },
  effects: {
    *init({ payload }, { put }) {
      yield put({
        type: 'fetchAffiliate',
        payload,
      });
    },

    *fetchAffiliate({ payload }, { call, put, all }) {
      try {
        const [response] = yield all([call(getAffiliate, payload)]);
        
        yield put({
          type: 'save',
          payload: {
            affiliate: response.data, 
          },
        });
      }
      catch (error) {
        redirectNotFound(error);
      };
    },

    *fetchAffiliateTopBenefits({ payload }, { call, put, all }) {
      const { id } = payload;
      const [response] = yield all([call(getAffiliateTopBenefits, id)]);
      yield put({
        type: 'save',
        payload: {
          topBenefits: response.data,
        },
      });
    },

    *fetchAffiliatePharmaciesConsumptions({ payload }, { call, put, all }) {
      const { id } = payload;
      yield put({
        type: 'save',
        payload: {
          consumptions: null,
        },
      });
      const [response] = yield all([call(getAffiliatePharmaciesConsumptions, id, payload)]);
      yield put({
        type: 'save',
        payload: {
          consumptions: response.data,
        },
      });
    },

    *fetchAffiliatePKIs({ payload }, { call, put }) {
      const response = yield call(getAffiliatePKIs, payload);
      yield put({
        type: 'save',
        payload: {
          pkis: response.data,
        },
      });
    },

    *fetchOdontogram({ payload }, { call, put }) {
      const response = yield call(getAffiliateOdontograms, payload);
      yield put({
        type: 'save',
        payload: {
          odontogram: response.data[0],
        },
      });
    },

    *setAffiliate({ payload }, { put }) {
      yield put({
        type: 'save',
        payload: {
          affiliate: payload,
        },
      });
    },

    *setOdontogram({ payload }, { put }) {
      yield put({
        type: 'save',
        payload: {
          odontogram: payload,
        },
      });
    },
  },
  reducers: {
    save(state, { payload }) {
      return { ...state, ...payload };
    },

    clear() {
      return {
        affiliate: undefined,
      };
    },
  },
};
export default Model;
